<template>
    <div v-if="status === 'gateway-success'" class="border mb-3">
        <kt-nav space="lg" size="lg" id="kt-nav">
            <kt-nav-item class="no-bullet">
                <div class="accordion accordion-toggle-arrow" id="accounting_info">
                    <div class="card" style="overflow:inherit">
                        <div class="card-header bg-transparent" id="headingOne">
                            <div class="card-title collapsed" data-toggle="collapse"
                                 data-target="#accountingForm"
                                 aria-controls="accountingForm">
                                {{ $t('reports.users.accounting_info') }}
                            </div>
                        </div>
                        <div id="accountingForm" class="collapse" aria-labelledby="accountingForm" data-parent="#accounting_info">
                            <div class="card-body">
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col lg="6" md="6" sm="12">
                                            <ul>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.total_transactions')}} :
                                                    {{gatewayStatistics.total_transactions}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li >
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.monthly_transactions')}} :
                                                    {{gatewayStatistics.monthly_transactions}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.daily_transactions')}} :
                                                    {{gatewayStatistics.daily_transactions}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                            </ul>
                                        </kt-col>
                                        <kt-col lg="6" md="6" sm="12">
                                            <ul>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.total_wage')}} :
                                                    {{gatewayStatistics.total_wage}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.unsettled_balance_gateway')}} :
                                                    {{gatewayStatistics.unsettled_balace}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                                <li class="mt-3">
                                                    {{$t('reports.gateways.settled_balance_gateway')}} :
                                                    {{gatewayStatistics.settled_amount}}
                                                    <span>{{' ' + $t('currency.rial')}}</span>
                                                </li>
                                            </ul>
                                            </kt-col>
                                        </kt-row>
                                </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </kt-nav>
        </div>
</template>

<script>

import {mapGetters} from "vuex";
import { gatewayStatus } from '@/constants/gatewayStatus'
import { AllShopTypes } from '@/constants/AllShopTypes'

export default {
    data() {
        return {
            'params' : {
                'hashid': this.$route.params.hashid,
                'shop_type': "PF"
            },
            is_starshop: this.$route.params.gateway_source === 'starshop-gateways'
        }
    },

    computed: {
        ...mapGetters('reports', [
            'gatewayStatistics','status'
        ])
    },

    mounted() {
        this.$store.dispatch('reports/gatewayDetails', {params : this.params, is_starshop : this.is_starshop})
    }
}
</script>

<style>

</style>